var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m445.8 121.1-119-119.1h-241.5c-10.6 0-19.2 8.6-19.2 19.2v340.7h379.7z",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.8 101.9c0 10.6 8.6 19.2 19.2 19.2h99.9l-119.1-119.1z",
    fill: "#dbdfe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.2 361.8v129c0 10.6 8.6 19.2 19.2 19.2h341.3c10.6 0 19.2-8.6 19.2-19.2v-129z",
    fill: "#f1786b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.6 340c-6.1 0-12-2.3-17.4-6.8-9.1-7.6-9.8-16-8.9-21.7 4.4-25.7 52.2-49.2 80-60.8 15.1-37.8 28.2-82.3 36.3-115.7-16.2-34.7-21.9-59.2-16.9-73.1 2.5-6.9 7.6-11.4 14.8-13l1-.2 1 .1c.8.1 7.9 1.2 13.7 9 7.5 10.2 9.2 26.7 5 49.1-1.2 6.4-3.2 15.6-5.8 26.6 14.8 30.8 35.6 64.8 52.6 88.4 14.2-2 27.7-2.7 39.1-1.5 21.3 2.2 25.8 11.5 26.6 16.9 1.2 7.9-4.6 16.1-14.5 20.3-13.7 5.8-36.1 4.3-54.3-19.3-.8-1-1.6-2.1-2.4-3.2-23.4 3.9-50.6 11.3-78.2 21.6-2.9 1.1-5.7 2.2-8.5 3.3-18.7 45.8-37 72.1-54.5 78.4-2.8 1.1-5.8 1.6-8.7 1.6zm47-73.1c-39.7 17.9-59.4 35.6-61.2 46.7-.4 2.4-.4 6.1 4.7 10.3 4.7 3.9 9.2 4.9 14.2 3.1 13.9-5 28.7-29 42.3-60.1zm117-33.7c13.5 15.9 28.7 17.2 37.9 13.2 4.8-2 7.5-5.4 7.2-7.3-.3-2-4.8-5.4-15.8-6.5-8.2-.8-18.1-.6-29.3.6zm-65.6-81.4c-6.1 23.5-14.4 51.8-24.1 79.2-1.7 4.7-3.3 9.2-5 13.6 21.7-8 47.9-15.8 72.8-20.5-13.4-19.1-29.9-45.6-43.7-72.3zm-9-90.5c-2.3.8-3.8 2.3-4.7 4.9-3.5 9.6 1.1 27.7 10 49.1.8-3.8 1.5-7.3 2.1-10.5 4.6-24.9.2-35.6-2.9-39.7-1.7-2.3-3.5-3.4-4.5-3.8z",
    fill: "#f1786b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eff3f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.4 428.2h-22.9v-23.3h22.9c4.3 0 7.8-3.5 7.8-7.8s-3.5-7.8-7.8-7.8h-30.6c-4.3 0-7.8 3.5-7.8 7.8v77.6c0 4.3 3.5 7.8 7.8 7.8s7.8-3.5 7.8-7.8v-31h22.9c4.3 0 7.8-3.5 7.8-7.8-.1-4.3-3.6-7.7-7.9-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.4 389.4h-15.8c-4.3 0-7.8 3.5-7.8 7.8v77.6c0 4.3 3.5 7.8 7.8 7.8s7.8-3.5 7.8-7.8v-31h8c15 0 27.2-12.2 27.2-27.2s-12.2-27.2-27.2-27.2zm0 38.8h-8v-23.3h8c6.4 0 11.6 5.2 11.6 11.6s-5.2 11.7-11.6 11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.4 389.4h-20.4c-4.3 0-7.8 3.5-7.8 7.8v77.6c0 4.3 3.5 7.8 7.8 7.8h20.4c25.7 0 46.6-20.9 46.6-46.6 0-25.8-20.9-46.6-46.6-46.6zm0 77.5h-12.6v-62.1h12.6c17.1 0 31 13.9 31 31 .1 17.2-13.9 31.1-31 31.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.63a198a9abf88a042aa03b26f8200329.svg";
export { ForwardRef as ReactComponent };